import React, { useState, useEffect } from "react";
import "./styling/home.css";
import "./styling/mobile.css";
import logo from "./assets/logo.png";
import ImageSlider from "./Slider";
import mail from "./assets/mail.svg";
import phone from "./assets/phone.svg";
import square from "./assets/homeSquare.webp";
import insta from './assets/insta.svg';

function Home() {
  const [fade, setFade] = useState("fade-in");
  const [isOpeningMenuSatiata, setOpeningMenuSatiata] = useState(false);

  useEffect(() => {
    const wrapper = document.getElementById("heroWrapper");
    if (!wrapper) return;

    let ticking = false;

    const updateParallax = () => {
      const scrollY = window.scrollY || window.pageYOffset;
      wrapper.style.backgroundAttachment = "scroll";
      wrapper.style.backgroundPosition = `center ${scrollY * 0.35}px`;
      ticking = false;
    };

    const onScroll = () => {
      if (window.innerWidth < 800) {
        wrapper.style.backgroundAttachment = "";
        wrapper.style.backgroundPosition = "";
        return;
      }
      if (!ticking) {
        window.requestAnimationFrame(updateParallax);
        ticking = true;
      }
    };

    onScroll();
    window.addEventListener("scroll", onScroll, { passive: true });

    return () => window.removeEventListener("scroll", onScroll);
  }, []);

async function getActivePdf(restaurant) {
  try {
      const response = await fetch(`https://deieznoi.a2hosted.com/dataservice/pdf/active/satiata`);
      if (response.ok) {
          const pdfBlob = await response.blob();
          const url = window.URL.createObjectURL(pdfBlob); // Create a URL for the PDF blob
          return url; // Return the URL
      } else {
          console.error("Failed to fetch active PDF: Response not OK");
          return null;
      }
  } catch (error) {
      console.error("Error fetching active PDF:", error);
      return null; // Return null on error
  }
}

let isFetchingPdf = false; // Prevent multiple simultaneous calls

  const handleOpenPdf = async (restaurant) => {

    const link = document.createElement("a");
    link.href = "";
    link.target = "_blank";
    document.body.appendChild(link);

    if (isFetchingPdf) {
      console.log("Already fetching the PDF. Exiting early.");
      return; // Prevent concurrent executions
    }

    setOpeningMenuSatiata(true);
  
    console.log("Starting to fetch the PDF...");
    isFetchingPdf = true; // Lock the execution
  
    const maxRetries = 3; // Maximum number of retry attempts
    const retryDelay = 2000; // Delay between retries in milliseconds
  
    const fetchWithRetry = async (retries) => {
      for (let attempt = 1; attempt <= retries; attempt++) {
        console.log(`Attempt ${attempt} to fetch the menu for ${restaurant}`);
        try {
          const menu = await getActivePdf(restaurant);
          console.log(`Menu fetched (Attempt ${attempt}):`, menu);
          if (menu && typeof menu === "string" && (menu.startsWith("http") || menu.startsWith("blob:"))) {
            console.log("Valid menu URL found. Returning the menu.");
            return menu; // Return the menu URL if valid
          } else {
            console.log(`Invalid menu URL (Attempt ${attempt}):`, menu);
          }
        } catch (error) {
          console.error(`Error during fetch (Attempt ${attempt}):`, error);
        }
  
        // Wait before retrying (skip delay after the last attempt)
        if (attempt < retries) {
          console.log(`Waiting ${retryDelay}ms before next attempt...`);
          await new Promise((resolve) => setTimeout(resolve, retryDelay));
        }
      }
      console.log("All attempts failed. Returning null.");
      return null; // Return null if all retries fail
    };
  
    try {
      const menu = await fetchWithRetry(maxRetries);
  
      if (menu) {
        console.log("Opening the menu:", menu);
       
        link.href = menu;
        link.download = `Menu_Satiata.pdf`;
        link.click();

          // Trigger the downlo
        console.log("Menu opened successfully. Exiting function.");
        return; // Exit the function immediately after opening the menu
      } else {
        console.log("Failed to fetch the menu after all retries.");
        alert("Er is iets mis gegaan met het openen van het Menu...");
      }
    } finally {
      console.log("Resetting the isFetchingPdf flag.");
      isFetchingPdf = false; // Unlock execution after completing
      setOpeningMenuSatiata(false);
    }
  };
 

  
  // useEffect(() => {
  //   const timer = setTimeout(() => {
  //     setFade("fade-out");
  //   }, 3000); // 3 seconds delay

  //   return () => clearTimeout(timer); // Cleanup the timer when component unmounts
  // }, []);

  return (
    <div id="homeWrapper">
      <div id="heroWrapper">
        <div id="logoWrapper">
          <img src={logo} alt="Satiata Logo"></img>
          <p>A new restaurant concept by <span>Pulcinos</span></p>
        </div>

        <div data-aos="zoom-in-up" className={fade} id="spacer">

          <a href="https://pulcinos.lurch.app/reservation/" target="_blank" rel="noopener noreferrer">
          <button id="menuButton">Reserveer een Tafel</button>
          </a>

          <button onClick={() => handleOpenPdf()} id="menuButton">Bekijk Menu</button>

        </div>

        
      </div>

      <div id="mainWrapper">

        <div id="contentWrapper">

          <div data-aos="zoom-in-up" id="textWrapper">
   

          <div className="welcomeWrapper">
          <h1>WELKOM BIJ</h1>
          <img src={logo} alt="Satiata Logo"></img>
          
          <p>
            Satiata is het kleine zusje van Pulcinos, gelegen aan de
            Piushaven in Tilburg. In onze gezellige, intieme zaak serveren
            we handgemaakte, verse gerechtjes die perfect te combineren zijn met
            een groot assortiment aan wijnen. De wijnen komen van onze eigen
            slijterij, pal naast de deur.
          </p>

          <p>
            Bij Satiata draait alles om genieten in een relaxte sfeer. Naast de
            vele wijnen kun je hier ook proeven van onze eigen Pulcinos likeuren
            en natuurwijnen. Kom langs voor een heerlijke avond vol smaken en
            gezelligheid!
          </p>
          <p>
            Bij Satiata ben je welkom voor lunch, diner of gewoon een borrel met
            een hapje.
          </p>

          <div className="menuButtons">

          <a href="https://pulcinos.lurch.app/reservation/" target="_blank" rel="noopener noreferrer">
          <button id="menuButton">Reserveer een Tafel</button>
          </a>

          <button onClick={() => handleOpenPdf()} id="menuButton">Bekijk Menu</button>
         

          </div>

          </div>

          </div>  

          <ImageSlider />

          <div data-aos="zoom-in-up" id="addressWrapper">

          
            <div id="mapsWrapper">
              <iframe src="https://www.google.com/maps/embed?pb=!1m18!1m12!1m3!1d4961.690224995806!2d5.091441392417288!3d51.55273909917329!2m3!1f0!2f0!3f0!3m2!1i1024!2i768!4f13.1!3m3!1m2!1s0x47c6bfc9f16dd6e7%3A0x25f69502f3cae3ff!2sPiushaven%205%2C%205017%20AN%20Tilburg!5e0!3m2!1snl!2snl!4v1748628554229!5m2!1snl!2snl" 
                allowFullScreen=""
                loading="lazy"
                referrerPolicy="no-referrer-when-downgrade"
                title="Maps"
              ></iframe>
            </div>

            <div>
              
              <div className="addressCol"></div>
              <div className="addressCol">
                <h3>Satiata Tilburg</h3>
                <p>Piushaven 5</p>
                <p>5017 AN</p>
                <br></br>
                <div id="openingWrapper">
                  <div className="openingCol">
                    <p>Ma</p>
                    <p>Di</p>
                    <p>Wo</p>
                    <p>Do</p>
                    <p>Vr</p>
                    <p>Za</p>
                    <p>Zo</p>
                  </div>

                  <div className="openingCol">
                    <p>Gesloten</p>
                    <p>Gesloten</p>
                    <p>17:00 - 23:00</p>
                    <p>17:00 - 23:00</p>
                    <p>13:00 - 23:00</p>
                    <p>13:00 - 23:00</p>
                    <p>13:00 - 23:00</p>
                  </div>
                </div>
                <br></br>
                <a href="tel:+31132033899">
                <p>
                  <img src={phone} alt=""></img>013-203-3899
                </p>
                </a>
                <a href="mailto:satiatatilburg@gmail.com">
                <p>
                  <img src={mail} alt=""></img>satiatatilburg@gmail.com
                </p>
                </a>
                <a href="https://www.instagram.com/satiata.tilburg/"  target="_blank" rel="noopener noreferrer" >
                <p>
                  <img src={insta} alt=""></img>@satiata.tilburg
                </p>
                </a>
              </div>
            </div>            
          </div>
        </div>
      </div>

      <div id="bottomSpacer">
        <img src={logo} alt=""></img>
        <p><span>©</span> Pulcinos – Alle rechten voorbehouden</p></div>
    </div>
  );
}

export default Home;
